export type EnterpriseSidebarPinMode = 'overlay' | 'pinned-collapsed' | 'pinned-expanded';

/** Enterprise sidebar — collapsed rail matches Tailwind `w-16` at 90% (`3.6rem`). */
export const ENTERPRISE_SIDEBAR_WIDTH_COLLAPSED = 'md:w-[3.6rem]';

/** Expanded panel: ~10% narrower than `14.4rem` (original `w-64` was reduced once already). */
export const ENTERPRISE_SIDEBAR_WIDTH_EXPANDED = 'md:w-[12.96rem]';

export const ENTERPRISE_SIDEBAR_RAIL_REM = '3.6rem';
export const ENTERPRISE_SIDEBAR_EXPANDED_REM = '12.96rem';

/**
 * Fixed main panel: `start` + `end-0` on the viewport (same containing block as the fixed aside).
 * Do not use padding-inline-start — it paints an empty lane beside the sidebar.
 */
export const ENTERPRISE_SIDEBAR_RAIL_CONTENT_START = 'start-0 md:start-[3.6rem]';
export const ENTERPRISE_SIDEBAR_EXPANDED_CONTENT_START = 'start-0 md:start-[12.96rem]';

/** Match chrome inset to the aside width (overlay always uses the rail lane). */
export function enterpriseSidebarContentStartClass(
  pinMode: EnterpriseSidebarPinMode,
  collapsed: boolean,
): string {
  if (pinMode === 'overlay') {
    return ENTERPRISE_SIDEBAR_RAIL_CONTENT_START;
  }
  return collapsed ? ENTERPRISE_SIDEBAR_RAIL_CONTENT_START : ENTERPRISE_SIDEBAR_EXPANDED_CONTENT_START;
}

/** @deprecated Use {@link enterpriseSidebarContentStartClass} — padding leaves a visible gap. */
export const ENTERPRISE_SIDEBAR_RAIL_OFFSET = 'md:ps-[3.6rem]';
/** @deprecated Use {@link enterpriseSidebarContentStartClass}. */
export const ENTERPRISE_SIDEBAR_EXPANDED_OFFSET = 'md:ps-[12.96rem]';
/** @deprecated Use {@link ENTERPRISE_SIDEBAR_RAIL_CONTENT_START}. */
export const ENTERPRISE_SIDEBAR_RAIL_PADDING = ENTERPRISE_SIDEBAR_RAIL_OFFSET;
/** @deprecated Use {@link ENTERPRISE_SIDEBAR_EXPANDED_CONTENT_START}. */
export const ENTERPRISE_SIDEBAR_EXPANDED_PADDING = ENTERPRISE_SIDEBAR_EXPANDED_OFFSET;

export const ENTERPRISE_SIDEBAR_LABEL_MAX = 'max-w-[9.315rem]';
